import { PANE_TRIGGER_SIZE } from '../constants/sizes';
import getItemWidth from './get-item-width';

const deriveItemsWidth = (items) =>
  items.reduce((totalWidth, item) => {
    const itemWidth = getItemWidth(item) || PANE_TRIGGER_SIZE;

    return totalWidth + itemWidth;
  }, 0);

export default deriveItemsWidth;
